/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { AuthenticationService as IAuthenticationService } from "App/Contracts";

export default class AuthenticationService implements IAuthenticationService {
    Token?: string;
}
